module.exports = "/packs/shares-4931105-3f0f183be7b6e72bd7b7bdcf11667a27.png";